import script from "./JpFinancial.vue?vue&type=script&setup=true&lang=ts"
export * from "./JpFinancial.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__